import './PaymentUpdate.css';

const PaymentUpdate = () => {
  return (
    <section className="payment-update">
      <p className="payment-subtitle">Payments Update</p>

      <h2 className="payment-title">
        24X7 Instant Deposit & Withdrawal
      </h2>

      <p className="payment-description">
        Ready for a payment experience that's both genuine and fast?
        At tredixo.store, we make your deposits & withdrawals smooth and swift.
        Choose UPI, NEFT, or RTGS with confidence.
      </p>

      <div className="payment-buttons">
        <button className="btn-outline-light">Why Tredixo?</button>
        <button className="btn-solid">Trade Now</button>
      </div>
    </section>
  );
};

export default PaymentUpdate;
